.ba{max-width:100%;}